var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 32.552L28.517 10.28C29.1143 10.1093 29.797 9.98133 30.565 9.896C31.333 9.768 32.0157 9.704 32.613 9.704C33.5517 9.704 34.4263 9.832 35.237 10.088C36.0903 10.3013 36.773 10.728 37.285 11.368C37.8397 12.008 38.117 12.9467 38.117 14.184V33.96H43.877C44.0477 34.3013 44.2183 34.7493 44.389 35.304C44.6023 35.8587 44.709 36.4773 44.709 37.16C44.709 38.2693 44.453 39.1013 43.941 39.656C43.429 40.168 42.725 40.424 41.829 40.424H38.117V49.064C37.8183 49.1067 37.3277 49.192 36.645 49.32C35.9623 49.448 35.301 49.512 34.661 49.512C33.2957 49.512 32.2503 49.2987 31.525 48.872C30.7997 48.4453 30.437 47.5493 30.437 46.184V40.424H13.541C12.8583 40.0827 12.261 39.528 11.749 38.76C11.237 37.9493 10.981 37.032 10.981 36.008C10.981 35.4107 11.045 34.8133 11.173 34.216C11.301 33.576 11.5143 33.0213 11.813 32.552ZM30.757 33.96L30.821 17.704H30.629L19.429 33.96H30.757Z",
    fill: "#DF1995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.8c36708a0a854f7b4e82a0666e42fa6f.svg";
export { ForwardRef as ReactComponent };